import { defineMessages } from 'react-intl';

const messages = defineMessages({
  label: {
    id: 'querystring_hidden_label_title',
    defaultMessage: 'URL parameter',
  },
  label_description: {
    id: 'querystring_hidden_label_description',
    defaultMessage:
      "Enter the name of the parameter to read from the page's link (e.g. entering user-code makes the field read ?user-code=... from the URL).",
  },
});
export const QuerystringHiddenSchemaExtender = (intl) => ({
  fields: [],
  properties: {
    label: {
      title: intl.formatMessage(messages.label),
      description: intl.formatMessage(messages.label_description),
      send_to_backend: true,
    },
  },
  required: [],
});
